import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'carbon-components-react';
import { CheckmarkOutline32, ArrowUpRight16 } from '@carbon/icons-react';
import { MainContainer, MainHeaderContainer } from 'layouts/components';
import { selectNewEnquiryDetails } from 'redux/lodgeEnquiry';
import Utils from 'utilities/helper.util';

export const EnquiryLodged: React.FC<Props | any> = () => {
  const isAppLoadedInFrame = window.self !== window.top;
  const enquiryDetails: any = useSelector(selectNewEnquiryDetails);

  const handleViewResponsesButtonClick = () => {
    if (enquiryDetails && !Utils.isObjectEmpty(enquiryDetails)) {
      const url = `/enquiries/${enquiryDetails.id}`;
      const win = window.open(url, '_blank');
      win && win.focus();
    }
  };

  const handleCloseIframe = () => {
    window.parent.postMessage(
      'Close BYDA Lodge Enquiry iframe',
      `${process.env.REACT_APP_LODGE_ENQUIRY_IFRAME_PARENT_DOMAIN}`
    );
  };

  return (
    <div
      id="enquiryLodged"
      data-testid="enquiryLodged"
      className={`enquiryLodged container--wrapper`}
    >
      <MainHeaderContainer
        enableHeaderGlobalBar={true}
        showAlternateHeaderBar={isAppLoadedInFrame || false}
      />
      <MainContainer>
        <div className="main-wrapper">
          <div className="success-lodged">
            <div className="success-lodged-icon">
              <CheckmarkOutline32 />
            </div>
            <div className="success-lodged-text">Thanks. Enquiry sent.</div>
          </div>
          <div className="action-button">
            <div className="action-button-view-response">
              <Button
                onClick={handleViewResponsesButtonClick}
                renderIcon={ArrowUpRight16}
              >
                View responses
              </Button>
            </div>
            <div className="action-button-close">
              <Button onClick={handleCloseIframe} kind="secondary">
                Close
              </Button>
            </div>
          </div>
        </div>
      </MainContainer>
    </div>
  );
};

type ownProps = {};

type Props = ownProps;

EnquiryLodged.displayName = 'EnquiryLodged';

export default React.memo(EnquiryLodged);
